import styles from "./ElementTooltipLabel.module.scss";
import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";

function ElementTooltipLabel({ node }) {
  const _label = nodeUtils.getLabel(node);

  return <div className={styles["tooltip__label"]}>{_label}</div>;
}

export default ElementTooltipLabel;
